<template>
<div class="chapter">
<div class="inner_page">
<div class="group"><a id="page_2"></a><div class="wrap"><div class="imgblock W98 H98"><img alt="" src="images/f0002-01.jpg"/></div></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Front02.vue?43bc980e